/** @jsxRuntime classic */ /** @jsx createElement */ import { createElement } from '@fluentui/react-jsx-runtime';
import * as React from 'react';
import { mergeClasses } from '@fluentui/react-components';
import { getIntrinsicElementProps, slot, assertSlots } from '@fluentui/react-utilities';
import { useItemLayoutStyles } from './ItemLayout.styles';
export const itemLayoutClassName = 'fui-ItemLayout';
export const ItemLayout = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = {
        components: {
            root: 'div',
            contentWrapper: 'div',
            contentMedia: 'div',
            header: 'div',
            headerMedia: 'div',
            startMedia: 'div',
            endMedia: 'div'
        },
        root: slot.always(getIntrinsicElementProps('div', {
            ...props,
            ref
        }), {
            elementType: 'div'
        }),
        contentMedia: slot.optional(props.contentMedia, {
            elementType: 'div'
        }),
        contentWrapper: slot.optional(props.contentWrapper, {
            renderByDefault: true,
            elementType: 'div'
        }),
        header: slot.optional(props.header, {
            elementType: 'div'
        }),
        headerMedia: slot.optional(props.headerMedia, {
            elementType: 'div'
        }),
        startMedia: slot.optional(props.startMedia, {
            elementType: 'div'
        }),
        endMedia: slot.optional(props.endMedia, {
            elementType: 'div'
        })
    };
    const styles = useItemLayoutStyles();
    state.root.className = mergeClasses(itemLayoutClassName, styles.root, state.root.className);
    if (state.contentWrapper) {
        state.contentWrapper.className = mergeClasses(styles.contentWrapper, state.contentWrapper.className);
    }
    if (state.contentMedia) {
        state.contentMedia.className = mergeClasses(styles.contentMedia, state.contentMedia.className);
    }
    if (state.header) {
        state.header.className = mergeClasses(styles.header, state.header.className);
    }
    if (state.headerMedia) {
        state.headerMedia.className = mergeClasses(styles.headerMedia, state.headerMedia.className);
    }
    if (state.startMedia) {
        state.startMedia.className = mergeClasses(styles.startMedia, state.startMedia.className);
    }
    if (state.endMedia) {
        state.endMedia.className = mergeClasses(styles.endMedia, state.endMedia.className);
    }
    assertSlots(state);
    return /*#__PURE__*/ createElement(state.root, null, state.startMedia && /*#__PURE__*/ createElement(state.startMedia, null), state.header && /*#__PURE__*/ createElement(state.header, null), state.headerMedia && /*#__PURE__*/ createElement(state.headerMedia, null), state.contentWrapper && /*#__PURE__*/ createElement(state.contentWrapper, null, state.root.children), state.contentMedia && /*#__PURE__*/ createElement(state.contentMedia, null), state.endMedia && /*#__PURE__*/ createElement(state.endMedia, null));
});
ItemLayout.displayName = 'ItemLayout';
